<div class="md:w-full md:h-full flex flex-col min-h-0">
  <div class="flex items-center justify-between mb-4">
    <p class="text-xs md:text-sm text-mg-gray m-0">
      Al regularizar tus marcaciones, generarás solicitudes que podrán ser aprobadas o rechazadas.
    </p>
    <button (click)="goBackList()"
      class="border border-mg-main-blue text-mg-main-blue rounded-xl text-sm flex items-center justify-center flex-shrink-0 ml-2 px-4 py-2 gap-1.5">
      <mg-icon iconName="arrow_back" iconClass="text-base text-mg-main-blue leading-none"></mg-icon>
      Volver
    </button>
  </div>

  <div class="flex flex-col md:flex-row flex-1 overflow-hidden min-h-0 gap-4">
    <div class="md:w-[480px] w-full flex-shrink-0 flex flex-col gap-3 overflow-hidden border border-mg-main-blue-light rounded-xl p-4">
      <div [matTooltip]="dateLockTooltip"
        [matTooltipDisabled]="!dateLockTooltip"
        matTooltipPosition="above">
        <mg-input-date
          label="Fecha"
          placeholder="DD/MM/AAAA"
          [inputControl]="fechaControl"
          [mode]="isDateLocked ? 'read' : 'update'"
          class="w-full"
          [min]="minDate"
          [max]="maxDate"
          [aDisabledDays]="disabledDays"
          [serie1]="fechasIncompletas"
          titleserie1="Marcas incompletas"
          cssserie1="!bg-mg-gray-light rounded-full p-2"
          [serie2]="fechasSinMarcacion"
          titleserie2="Sin Marcación"
          cssserie2="!bg-mg-red rounded-full p-2"
        ></mg-input-date>
      </div>

      <div class="flex flex-col flex-1 overflow-y-auto pr-1">
        @if (cannotDeleteMarks && marksIntervals.length > 0 && hasIntervals) {
          <div class="flex flex-col gap-1.5 px-3 py-2.5 rounded-xl bg-mg-main-blue-light border border-mg-main-blue mb-4">
            <div class="flex items-center gap-1.5 text-mg-main-blue-dark text-xs font-bold">
              <mg-icon iconName="info" iconClass="text-sm leading-none flex-shrink-0 text-mg-main-blue-dark"></mg-icon>
              <span>No puedes eliminar marcas · tienes el mínimo recomendado</span>
            </div>
            <div class="flex flex-col gap-0.5 pl-5">
              @for (interval of marksIntervals; track interval.inicio; let i = $index) {
                <span class="text-xs text-mg-main-blue-dark font-medium">• Intervalo {{ i + 1 }}: {{ interval.inicio }} – {{ interval.fin }}</span>
              }
            </div>
          </div>
        }
        <mg-interval-list
          [fecha]="selectedDate"
          [nId_Colaborador]="nId_Colaborador"
          [editMode]="true"
          [loadAdjacentJornadas]="true"
          (intervalsLoaded)="onIntervalsLoaded($event)"
          [accionesAgregadas]="acciones"
          [allowedActionType]="currentActionType"
          [minMarksCount]="effectiveMinMarksCount"
          (cannotDeleteChange)="onCannotDeleteChange($event)"
          (loadingChange)="isLoadingIntervals = $event"
          (editarMarca)="selectedMarks($event.nInterval, $event.nIndex, $event.nType_Mark, $event.sHour, $event.sOriginalHour)"
          [ngStyle]="{'display': isLoadingIntervals || hasIntervals ? 'flex' : 'none', 'flex': '1', 'flex-direction': 'column'}"
        ></mg-interval-list>
        @if (!hasIntervals && !isLoadingIntervals) {
          <div class="flex flex-col items-center justify-center flex-1 px-4">
            <img src="../../../../../assets/png/mgalert/no_marks.png" alt="Sin marcaciones" class="w-24 h-24 sm:w-40 sm:h-40 md:w-56 md:h-56 xl:h-80 xl:w-80 object-contain opacity-80" />
            <p class="text-xs sm:text-sm font-semibold text-mg-main-blue-dark text-center leading-snug max-w-[160px] sm:max-w-[220px] pt-2">
              No hay registros de asistencia para este día.
            </p>
          </div>
        }
      </div>

      <button (click)="addNewMark()" [disabled]="currentActionType !== null && currentActionType !== 'add'"
        class="w-full flex items-center justify-center gap-2 bg-mg-main-blue text-white rounded-xl py-2 text-sm font-semibold disabled:opacity-40 disabled:cursor-not-allowed">
        <mg-icon iconName="add" iconClass="text-xl text-white"></mg-icon>
        Agregar Nueva Marcación
      </button>
    </div>

    <div class="flex-1 flex flex-col overflow-y-auto min-h-0 border border-mg-main-blue-light rounded-xl p-4">
      <div class="flex items-center justify-between mb-4 flex-shrink-0">
        <span class="text-sm md:text-lg font-semibold text-mg-main-blue-dark">Acciones Agregadas</span>
        <span class="text-xs font-semibold text-mg-main-blue-dark px-3 py-1 rounded-full border border-mg-main-blue">
          {{ acciones.length }} Acciones
        </span>
      </div>

      @if (markSelected) {
        <div class="flex-shrink-0 mb-3">
          <mg-action-form
            [markSelected]="markSelected"
            [esEliminar]="esEliminar"
            [actionDate]="actionDate"
            [selectedDate]="selectedDate"
            [accionForm]="accionForm"
            [intervals]="intervals"
            [adjacentIntervals]="adjacentIntervals"
            [acciones]="acciones"
            (cancelAction)="cancelAction()"
            (saveAction)="addAction($event)"
            (markDateChanged)="onMarkDate($event)"
          ></mg-action-form>
        </div>
      }

      @if (acciones.length === 0 && !markSelected) {
        <div class="flex flex-col items-center justify-center flex-1">
          <div class="w-16 h-16 flex items-center justify-center">
            <mg-icon iconName="error_outline" iconClass="text-3xl text-mg-gray"></mg-icon>
          </div>
          <p class="text-md font-semibold text-mg-gray text-center m-0">No has agregado acciones aún</p>
          <p class="text-sm text-mg-gray-light mt-1 m-0 text-center">Selecciona una marcación o crea una nueva</p>
        </div>
      } @else {
        <div class="flex flex-col gap-2 flex-shrink-0">
          @for (accion of acciones; track accion.nInterval + '-' + accion.nType_Mark + '-' + accion.actionType) {
            <div class="flex items-start justify-between border border-mg-main-blue-light rounded-xl px-4 py-3">
              <div class="flex-1 min-w-0 pr-2">
                <span class="text-sm text-mg-main-blue-dark block break-words" [innerHTML]="getActionMessage(accion)"></span>
                <span class="text-xs text-mg-gray mt-1 block break-words">
                  {{ accion.sReason }}
                </span>
              </div>
              <button (click)="deleteAction(accion.nInterval, accion.nType_Mark, accion.actionType)"
                class="w-6 h-6 rounded-full bg-mg-red-light flex items-center justify-center flex-shrink-0 mt-0.5">
                <mg-icon iconName="delete" iconClass="text-lg text-mg-red-dark"></mg-icon>
              </button>
            </div>
          }
        </div>

        @if (!markSelected) {
          @if (intervalValidationError) {
            <div class="mt-4 flex items-start gap-2 text-mg-red-dark bg-mg-red-light px-3 py-2 rounded-xl text-sm border border-mg-red-light flex-shrink-0">
              <mg-icon iconName="info" iconClass="text-lg leading-none mt-0.5"></mg-icon>
              <span [innerHTML]="intervalValidationError"></span>
            </div>
          }

          <div class="mt-4 flex gap-3 flex-shrink-0">
            <button (click)="limpiarAcciones()"
              class="flex-1 flex items-center justify-center gap-2 bg-mg-red-light text-mg-red-dark rounded-xl py-2 text-sm font-semibold border border-mg-red">
              Cancelar
            </button>

            <button (click)="sendRequest()"
              [disabled]="acciones.length === 0 || !!intervalValidationError || debeEliminarMarcaFuera"
              class="flex-1 flex items-center justify-center gap-2 bg-mg-green text-white rounded-xl py-2 text-sm font-semibold disabled:opacity-40 disabled:cursor-not-allowed">
              Enviar ({{ acciones.length }})
            </button>
          </div>
        }
      }
    </div>
  </div>
</div>

@if (spinner) {
  <mg-spinner [show]="true"></mg-spinner>
}